import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { RSMEmployeeDetailsReportSchema } from "../RSMEmployeeDetailsReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import MaterialTable from "material-table";
import _ from 'lodash';


const screenCode = 'CONTRACTEMPLOYEES'

export function RSMEmployeeDetailsReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        estateID: "0"
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(RSMEmployeeDetailsReportSchema).options({ allowUnknown: true });
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);



    const [csvTotalRow, setCsvTotalRow] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const initalCsvHeaders = [
        { label: "Contractor Code", value: "employeeCode" },
        { label: "Contractor Name", value: "firstName" },
        { label: "Card Number", value: "cardNumber" }

    ];
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: ""
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        if (searchData.groupID != "0") {
            trackPromise(
                getEstatesForDropdown()
            )
        }
    }, [searchData.groupID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCONTRACTORS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getEstatesForDropdown() {
        const data = await service.getEstatesByGroupID(searchData.groupID);
        setEstates(data);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, RSMEmployeeDetailsReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {

        setIsTableHide(true);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        let model = {
            groupID: parseInt(searchData.groupID),
            estateID: parseInt(searchData.estateID)
        }
        const reportData = await service.GetRSMEmployeeDetails(model);
        createDataForExle(reportData);
        setSelectedSearchData();

        if (reportData.length > 0) {
            setIsTableHide(false);
            setReportData(reportData);
        }

    }

    async function createDataForExle(data) {
        setExcelData(data)
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: estates[searchData.estateID]
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function createFile() {
        var settings = {
            sheetName: 'Contractors',
            fileName: 'Contractors - ' + selectedSearchValues.group + " - " + selectedSearchValues.estate,
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(excelData)
        copyOfCsv.push(csvTotalRow)

        copyOfCsv.push({}, {
            employeeCode: "Group: " + selectedSearchValues.group,
            firstName: "Factory: " + selectedSearchValues.estate
        });

        xlsx(initalCsvHeaders, copyOfCsv, settings, true)
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Contractors"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md">
                                    <InputLabel shrink id="estateID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="estateID"
                                        id="estateID"
                                        name="estateID"
                                        value={searchData.estateID}
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(estates)}
                                    </Select>
                                    {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {isTableHide ? null :
                                <Grid hidden={isTableHide} item md={12} xs={12}>
                                    <MaterialTable
                                        columns={[
                                            {
                                                title: 'Contractor Number', field: 'employeeCode',
                                                headerStyle: { fontWeight: "bold" },
                                                editable: 'never'
                                            },
                                            {
                                                title: 'Contractor Name', field: 'firstName',
                                                headerStyle: { fontWeight: "bold" },
                                                editable: 'never'
                                            },
                                            {
                                                title: 'Card Number', field: 'cardNumber',
                                                headerStyle: { fontWeight: "bold" },
                                                editable: 'never'
                                            },
                                        ]}
                                        data={reportData}
                                        options={{
                                            exportAllData: true,
                                            showTitle: false,
                                            headerStyle: { textAlign: "left", height: '1%' },
                                            cellStyle: { textAlign: "left" },
                                            columnResizable: false,
                                            pageSize: 10
                                        }}
                                    />
                                </Grid>
                            }
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Contractor Details'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} data={reportData}
                                            searchData={selectedSearchValues} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



